import React from 'react'
import { GetServerSideProps } from 'next'
import { ConsumerPage } from '../src/model'
import { HomePage as HomeEntryPage } from '../src/page/HomePage'
import { getLayout } from '../src/layouts/MainLayout'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getTheme } from '../src/utils/server/convergence'

const I18N_NAMESPACE = [
  'common',
  'terminalError',
  'index',
  'account',
  'payments',
  'upcomingPayments',
  'cardScan',
  'oauth',
  'ach',
  'orders',
  'loyalty',
  'payMonthly',
]

const HomePage: ConsumerPage = (props) => <HomeEntryPage {...props} />
HomePage.getLayout = getLayout()

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { theme } = await getTheme(context)
  return {
    props: {
      theme,
      ...(await serverSideTranslations(context.locale as string, I18N_NAMESPACE)),
    },
  }
}

export default HomePage
